var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReasonableCost = function SvgReasonableCost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0EDED",
    rx: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#reasonable-cost_svg__a)",
    rx: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#reasonable-cost_svg__b)",
    rx: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#reasonable-cost_svg__c)",
    fillOpacity: 0.63,
    rx: 32
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    fillOpacity: 0.33,
    rx: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010203",
    d: "M13.892 40.142c0 2.585 5.87 4.682 13.11 4.682 3.398 0 6.493-.462 8.822-1.22a10.3 10.3 0 0 0 3.589 2.728c-1.76 1.845-6.65 3.175-12.41 3.175-7.24 0-13.11-2.097-13.11-4.683z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010203",
    d: "M13.892 33.776c0 2.586 5.87 4.683 13.11 4.683 2.34 0 4.535-.221 6.436-.605a10.2 10.2 0 0 0 1.396 4.36c-2.185.582-4.896.928-7.831.928-7.24 0-13.11-2.097-13.11-4.683v-4.683Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#010203",
    d: "M13.892 27.411c0 2.586 5.87 4.683 13.11 4.683 3.136 0 6.014-.395 8.27-1.051a10.24 10.24 0 0 0-1.842 5.13c-1.899.383-4.092.603-6.427.603-7.24 0-13.11-2.096-13.11-4.682V27.41Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#010203",
    d: "M40.113 25.729c0 2.585-5.87 4.682-13.11 4.682s-13.11-2.097-13.11-4.683v-4.682c0 2.586 5.87 4.683 13.11 4.683s13.11-2.097 13.11-4.683z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#010203",
    d: "M26.842 14.49c7.24 0 13.11 2.097 13.11 4.683s-5.87 4.683-13.11 4.683-13.11-2.097-13.11-4.683 5.869-4.683 13.11-4.683"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#010203",
    fillRule: "evenodd",
    d: "M44.365 27.514a9.365 9.365 0 0 1 9.364 9.365 9.365 9.365 0 1 1-18.729 0 9.366 9.366 0 0 1 9.365-9.365m5.008 5.695a1.17 1.17 0 0 0-1.654.066l-4.793 5.192-2.415-2.416a1.172 1.172 0 0 0-1.657 1.655l2.59 2.589a2.107 2.107 0 0 0 3.037-.06l4.959-5.372a1.17 1.17 0 0 0-.067-1.654",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-cost_svg__a",
    x1: -61.464,
    x2: 212.244,
    y1: 32,
    y2: 31.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895FFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9E7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-cost_svg__b",
    x1: 6.624,
    x2: 61.947,
    y1: 64,
    y2: 64.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#3682FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reasonable-cost_svg__c",
    x1: -15.203,
    x2: 106.834,
    y1: 31.886,
    y2: 31.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgReasonableCost;